import Vue from "vue";
import Tawk from "vue-tawk";

Vue.use(Tawk, {
  tawkSrc: "https://embed.tawk.to/5eec12fe4a7c6258179ae932/1emifvvqo"
});

export default Tawk;
